module.exports = Promise.all([__parcel__import__("duLj1"), __parcel__import__("3K2Le")]).then(() => parcelRequire('3pHq1'));